
export default {
  props: {
    video: {
      type: String,
      default: '',
    },
  },
}
